export const translationKeys = {
    "en": {
      "opens": "opens",
      "closes": "closes",
      "https://schema.org/DayOfWeek": "day of week",
      "https://schema.org/Monday": "Monday",
      "https://schema.org/Tuesday": "Tuesday",
      "https://schema.org/Wednesday": "Wednesday",
      "https://schema.org/Thursday": "Thursday",
      "https://schema.org/Friday": "Friday",
      "https://schema.org/Saturday": "Saturday",
      "https://schema.org/Sunday": "Sunday",
      "Monday": "Montag",
      "Tuesday": "Dienstag",
      "Wednesday": "Mittwoch",
      "Thursday": "Donnerstag",
      "Friday": "Freitag",
      "Saturday": "Samstag",
      "Sunday": "Sonntag",
      "mon": "Monday",
      "tue": "Tuesday",
      "wed": "Wednesday",
      "thu": "Thursday",
      "fri": "Friday",
      "sat": "Saturday",
      "sun": "Sunday",
      "MondayAbbr": "Mon",
      "TuesdayAbbr": "Tue",
      "WednesdayAbbr": "Wed",
      "ThursdayAbbr": "Thu",
      "FridayAbbr": "Fri",
      "SaturdayAbbr": "Sat",
      "SundayAbbr": "Sun"
    },
    "de": {
      "opens": "öffnet",
      "closes": "schließt",
      "https://schema.org/DayOfWeek": "Wochentag",
      "https://schema.org/Monday": "Montag",
      "https://schema.org/Tuesday": "Dienstag",
      "https://schema.org/Wednesday": "Mittwoch",
      "https://schema.org/Thursday": "Donnerstag",
      "https://schema.org/Friday": "Freitag",
      "https://schema.org/Saturday": "Samstag",
      "https://schema.org/Sunday": "Sonntag",
      "Monday": "Montag",
      "Tuesday": "Dienstag",
      "Wednesday": "Mittwoch",
      "Thursday": "Donnerstag",
      "Friday": "Freitag",
      "Saturday": "Samstag",
      "Sunday": "Sonntag",
      "mon": "Montag",
      "tue": "Dienstag",
      "wed": "Mittwoch",
      "thu": "Donnerstag",
      "fri": "Freitag",
      "sat": "Samstag",
      "sun": "Sonntag",
      "MondayAbbr": "Mo",
      "TuesdayAbbr": "Di",
      "WednesdayAbbr": "Mi",
      "ThursdayAbbr": "Do",
      "FridayAbbr": "Fr",
      "SaturdayAbbr": "Sa",
      "SundayAbbr": "So"
    },
    "es": {
      "opens": "abre",
      "closes": "cierra",
      "https://schema.org/DayOfWeek": "día de la semana",
      "https://schema.org/Monday": "lunes",
      "https://schema.org/Tuesday": "martes",
      "https://schema.org/Wednesday": "miércoles",
      "https://schema.org/Thursday": "jueves",
      "https://schema.org/Friday": "viernes",
      "https://schema.org/Saturday": "sábado",
      "https://schema.org/Sunday": "domingo",
      "Monday": "Montag",
      "Tuesday": "Dienstag",
      "Wednesday": "Mittwoch",
      "Thursday": "Donnerstag",
      "Friday": "Freitag",
      "Saturday": "Samstag",
      "Sunday": "Sonntag",
      "mon": "Lunes",
      "tue": "Martes",
      "wed": "Miércoles",
      "thu": "Jueves",
      "fri": "Viernes",
      "sat": "Sábado",
      "sun": "Domingo",
      "MondayAbbr": "Lun",
      "TuesdayAbbr": "Mar",
      "WednesdayAbbr": "Mié",
      "ThursdayAbbr": "Jue",
      "FridayAbbr": "Vie",
      "SaturdayAbbr": "Sáb",
      "SundayAbbr": "Dom"
    }
  }
  